
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Card, CardActions, CardContent, CardMedia, Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Paper, Stack, styled } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import AppPromotion from './AppPromotion';


const items = [
    {title:"Contact Us",description:"With our state-of-the-art app, find and reserve your perfect spot in seconds. Say hello to parking bliss!"},
    {title:"Chat",description:"9:30 AM - 8:30 PM EST 7 Days a Week"},
    {title:"Message",description:"ext (618) 867.4225 9:30 AM - 8:30 PM EST 7 Days a Week"},
]

const values = [
    "Innovation – We embrace technology to create smarter, faster, and simpler solutions.",

    "Security – We prioritize the safety of users, data, and access at every level.",

    "Efficiency – We streamline operations for businesses and users through intelligent automation.",

    "Transparency – We build trust with honest communication and reliable service.",

    "Customer Focus – We design every experience around real user needs and satisfaction.",
]

export default function ContactUs() {
    return (
        <>
            <Container id = "contact-us" maxWidth = {'xl'}  component='main'sx={{backgroundColor:"#fafafa"}}>
                <Grid container columns={12} sx={{py:8,my:4}}>
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                    
                    <Grid item xs={10} md ={3} sm={3} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Contactanos
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                            Torre Access Q, No. 233, Cholula Rivadiaba, 72376, Puebla, Pue.
                            </Typography>

                            <Typography component="p"  variant="h3" color="black" sx={{fontWeight:'bolder'}} >
                            Telefono(s):
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                               +52 221 193 03 63
                            </Typography>
                            <Typography variant="body1" gutterBottom color="black">
                               +52 56 2333 44 87
                            </Typography>
                        </Stack> 
                    </Grid>

                    <Grid item xs={10} md ={7} sm={7} align="right" >  
           
                    </Grid>
                    
                    <Grid item xs={1} md ={1} sm={1} align="left" />  
                </Grid>
            </Container>
            <Container id = "app" maxWidth = {"xl"}  component='main'>
                <Grid container columns={12} sx={{py:8}}>
                    <Grid item xs={12} md ={8} sm={8} align="left" >  
                        <Stack spacing={2} >
                            <Typography component="p"  variant="h4"color="secondary" >
                            Descarga nuestra app
                            </Typography>
                            <Typography variant="body1" gutterBottom color="text.secondary">
                            ¡Diga adiós al dolor de cabeza de encontrar un lugar seguro para estacionar! Cqurity le ofrece servicios de acceso a estacionamiento de primer nivel, diseñados para hacerle la vida más fácil. Ya sea que esté apurado para ir a una reunión, ir de compras al centro o planear un día relajante, cubrimos sus necesidades de estacionamiento.
                            </Typography>
                        
                        </Stack> 
                    </Grid>
                    <Grid item xs={12} md ={4} sm={4} align="right" >  
                        <img
                            width="296"
                            height="409" 
                            src="https://firebasestorage.googleapis.com/v0/b/demos-a64ab.appspot.com/o/landing%2Fhand_app.png?alt=media&token=364790ef-d870-4053-bbc7-c0189fca4eb7"
                            alt="Live from space album cover"
                        />            
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}